/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { call, put, SagaReturnType, takeLatest } from "redux-saga/effects";
import { formatError } from "utils/errorHelper";
import api from "_config/api";

export interface TiposRequerimento {
  id: string;
  ordem?: number;
  nome: string;
  descricao: string;
}

interface State {
  isRequesting: boolean;
  successPayload: TiposRequerimento[];
  errors: string[];
}

const initialState: State = {
  isRequesting: false,
  successPayload: [],
  errors: []
};

const obterTiposRequerimentosSlice = createSlice({
  name: "licenciamentourbano@obterTiposRequerimentos",
  initialState,
  reducers: {
    obterTiposRequerimentos: (state): void => {
      state.isRequesting = true;
      state.errors = [];
    },
    obterTiposRequerimentosSuccess: (
      state,
      action: PayloadAction<TiposRequerimento[]>
    ): void => {
      state.isRequesting = false;
      state.successPayload = action.payload;
    },
    obterTiposRequerimentosFailed: (
      state,
      action: PayloadAction<string[]>
    ): void => {
      state.isRequesting = false;
      state.errors = action.payload;
    }
  }
});

function* sagaFunction(params: { type: string }) {
  try {
    const response: SagaReturnType<typeof api> = yield call(
      api.get,
      `api/v1/cidadao/licenciamentourbano`
    );

    const { data } = response;

    yield put(obterTiposRequerimentosSuccess(data));
  } catch (error) {
    yield put(obterTiposRequerimentosFailed(formatError(error)));
  }
}

export const {
  obterTiposRequerimentos,
  obterTiposRequerimentosSuccess,
  obterTiposRequerimentosFailed
} = obterTiposRequerimentosSlice.actions;

export const { reducer } = obterTiposRequerimentosSlice;

export const saga = takeLatest(obterTiposRequerimentos.type, sagaFunction);
